import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useQuickLinksQuery } from 'api';
import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
import { Backdrop, GoBackButtonWithTitle, PageWrapper } from 'components';
import { CreateButton } from 'features/documentCategories/components/DocumentCategories/styled';
import { Links } from 'settings';
import { theme } from 'styles';

import { QuickLinksList, RecommendedLinks } from '../../components';
import { ContentW } from './styled';

export function QuickLinksPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { links, isLoading: isLoadingLinks } = useQuickLinksQuery();

  return (
    <PageWrapper>
      <ContentW>
        <GoBackButtonWithTitle
          title={t('common.back')}
          onClick={() => navigate(-1)}
          containerSx={{
            marginTop: 0,
          }}
          Actions={
            <CreateButton
              startIcon={<AddIcon style={{ fill: theme.palette.common.white }} />}
              onClick={() => navigate(Links.we.quickLinks.createLink)}
              style={{
                height: '56px',
                padding: '16px',
                backgroundColor: theme.palette.info.main,
                color: theme.palette.common.white,
                fontSize: '14px',
                fontWeight: 400,
                borderRadius: '8px',
                textTransform: 'none',
                marginRight: '16px',
              }}
            >
              {t('quickLinks.add')}
            </CreateButton>
          }
        />
        <QuickLinksList isLoading={isLoadingLinks} links={links} />
        <RecommendedLinks setIsLoading={setIsLoading} />
        {isLoading && <Backdrop />}
      </ContentW>
    </PageWrapper>
  );
}
